import {createContext, useCallback, useContext, useState} from "react";
import {BOOKING_POPUP_ENABLED} from "conts/features";
import {BookingPopup} from "./BookingPopup";

const BookingPopupContext = createContext(null);

/**
 * One booking popup per instructor page. Buttons on the page open it with
 * openBooking({showDates}). The popup stays mounted after the first open, so
 * its progress and the selected times survive closing and reopening.
 */
export const BookingPopupProvider = ({classDetail, children}) => {
    const [mounted, setMounted] = useState(false);
    const [show, setShow] = useState(false);
    const [openRequest, setOpenRequest] = useState({showDates: false, n: 0});

    const openBooking = useCallback(({showDates = false} = {}) => {
        setMounted(true);
        setShow(true);
        setOpenRequest((prev) => ({showDates, n: prev.n + 1}));
    }, []);

    if (!BOOKING_POPUP_ENABLED) return children;

    return (
        <BookingPopupContext.Provider value={openBooking}>
            {children}
            {mounted && classDetail && (
                <BookingPopup show={show} onClose={() => setShow(false)} classDetail={classDetail} openRequest={openRequest}/>
            )}
        </BookingPopupContext.Provider>
    );
};

/** openBooking function, or null when the popup is turned off. */
export const useBookingPopup = () => useContext(BookingPopupContext);
